












import { Component, Prop, Vue } from 'vue-property-decorator';
import { Toast } from 'vant';

@Component
export default class SendVerifyCode extends Vue {
    //手机号码
    @Prop({
        type: String,
        required: true
    })
    public mobile!: string;

    //间隔时间
    @Prop({
        type: Number,
        default: 60
    })
    public delay!: number;

    //秒
    public second: number = 0;

    //倒计时
    private countDown(delay: number) {
        this.second = delay
        if (delay > 0) {
            setTimeout(() => {
                this.countDown(delay - 1);
            }, 1000);
        }
    }
    //发送
    public onSend() {
        if (this.mobile == '') {
            Toast.fail('请输入手机号码');
        } if (this.mobile.length < 11) {
            Toast.fail('请输入正确的手机号码');
        } else {
            this.axios.post(this.$api.SEND_VERIFY_CODE, {
                mobile: this.mobile,
                enableEncrypt: true
            }).then((res: any) => {
                if (res.code == 1) {
                    this.countDown(this.delay);
                    Toast.success(res.message);
                } else {
                    Toast.fail(res.message);
                }
            });
        }
    }
}
